<template>
  <div class="d-flex flex-column-fluid">
    <!--begin::Container-->
    <div class="container">
      <div class="row my-2">
        <div class="col-6 text-left">
          <h3 class="mt-2">Products</h3>
        </div>
        <div class="col-6 text-right">
          <button
            ref="refresh"
            @click="showProductPanel(true)"
            class="btn btn-primary font-weight-bolder font-size-sm mx-1 add-product"
          >
            Add Product
          </button>
        </div>
      </div>

      <!--Add Product-->
      <div v-if="openProductPanel" class="card card-custom card-custom-bordered mb-5">
        <div class="card-body">
          <div class="row">
            <div class="col-xs-12 col-md">
              <div>
                <b-form-group label="Name" label-for="name">
                  <b-form-input
                    v-model="$v.form.name.$model"
                    :state="validateState('name')"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="name"
                    placeholder=""
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Name is required.
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
            <div class="col-xs-12 col-md">
              <div>
                <b-form-group label="Price" label-for="price">
                  <b-form-input
                    v-model="$v.form.price.$model"
                    :state="validateState('price')"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="price"
                    placeholder=""
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Price is required.
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
            <div class="col-xs-12 col-md">
              <div>
                <b-form-group label="Unit" label-for="unit">
                  <b-form-input
                    v-model="$v.form.unit.$model"
                    :state="validateState('unit')"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="unit"
                    placeholder=""
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Unit is required.
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
            <div v-if="globalTaxtType == 'Vatable'" class="col-xs-12 col-md">
              <div>
                <b-form-group label="Tax Type" label-for="taxtype">
                  <b-form-select
                    v-model="$v.form.taxtype.$model"
                    :options="options.taxtype"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="taxtype"
                    placeholder=""
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
            </div>
          </div>
          <div class="row text-right">
            <div class="col-12">
              <button class="btn btn-light-primary py-2 p-x2 mx-1" @click="showProductPanel(false)">
                Cancel
              </button>
              <button 
              ref="saveandsubmit"
              :disabled="this.isBusy || $v.$invalid || !$v.$anyDirty"
              type="button"
              class="btn btn-light-primary py-2 p-x2 mx-1"
              @click="save(true)">
                Save and Add Another
              </button>
              <button 
              ref="submit"
              :disabled="this.isBusy || $v.$invalid || !$v.$anyDirty"
              type="button"
              class="btn btn-primary py-2 p-x2 mx-1"
              @click="save(false)"
              >
                Save Product
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--End of Add Product-->
      <!--No Products Placeholder-->
      <div class="card card-custom">
        <div v-if="items.data.length == 0" class="card-body text-center">
          <label class="py-5">Add your products to speed up issuing of receipts and sales invoices</label>
        </div>

        <div v-else class="card-body pt-5 pb-3">
          <!--begin::Table-->
          <div class="table-responsive">
            <table
              class="table table-head-custom table-head-bg table-borderless table-vertical-center table-hover"
            >
              <thead>
                <tr class="text-uppercase">
                  <th class="pl-7" style="min-width: 150px">
                    <span class="text-dark-75">Name</span>
                  </th>
                  <th style="min-width: 150px">Price</th>
                  <th style="min-width: 100px">Unit</th>
                  <th v-if="globalTaxtType == 'Vatable'" style="min-width: 100px">Type</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in items.data" :key="index+'_'+item.BusinessItemId">
                  <td class="py-2">
                    <div class="d-flex align-items-center">
                      <div>
                          <a
                            class="text-primary font-weight-bolder text-hover-secondary mb-1 font-size-lg"
                            href="#"
                            @click="edit(item)"
                            >
                            {{ item.MetadataObject.Description}}
                          </a>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="text-muted d-block">{{ item.MetadataObject.Price | numFormat("0,0.00") }}</span>
                  </td>
                  <td>
                    <span class="text-muted d-block">{{ item.MetadataObject.Unit }}</span>
                  </td>
                  <td v-if="globalTaxtType == 'Vatable'">
                    <span class="text-muted d-block">{{ item.MetadataObject.TaxType }}</span>
                  </td>
                  <td>
                    <button
                        :disabled="isBusy"
                        class="text-muted d-block"
                        type="button"
                        @click="confirmDeleteItem(item)"
                      >
                        <i class="flaticon-delete"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!--End of No Products Placeholder-->

      <!--begin::Pagination-->
      <!-- <div class="card card-custom">
        <div class="card-body pt-0 pb-2">
          <Paginator
            v-bind:currentPage="search.currentPage"
            v-bind:rowsPerPage="search.rowsPerPage"
            v-bind:totalRows="items.totalRows"
            @update-currentpage="
              value => {
                search.currentPage = value;
                this.submitsearch();
              }
            "
            @update-pagesize="
              value => {
                search.currentPage = 1;
                setPageSize(value);
              }
            "
          />
        </div>
      </div> -->
      <!--end::Pagination-->
    </div>
    <!--end::Container-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/view/pages/easyreceipt/api";
import Vue from "vue";
import vueNumeralFilterInstaller from "vue-numeral-filter";
// import Paginator from "@/view/content/widgets/paginator2.vue";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";

Vue.use(vueNumeralFilterInstaller);
Vue.use(require("vue-moment"));
Vue.filter("numFormat", numFormat(numeral));

export default {
  components: {},
  mixins: [validationMixin],
  data() {
    return {
      openProductPanel : false,
      form : {
        id : "",
        name : "",
        unit : "",
        price : "",
        taxtype : this.globalTaxtType
      },
      isBusy: false,
      filters: {},
      options: {
        taxtype: [
          {
            text: "Vatable",
            value: "Vatable"
          },
          {
            text: "Non-Vatable",
            value: "Non-Vatable"
          },
          {
            text: "Zero rated",
            value: "Zero rated"
          }
        ]
      },
      search: {
        currentPage: 1,
        rowsPerPage: 6
      },
      items: {
        data: [],
        totalRows: 0,
        indexStart: 0
      }
    };
  },
  validations: {
    form: {
      name: { required },
      price: { required },
      unit: { required },
      taxtype: {}
    }
  },
  computed: {
    ...mapGetters(["layoutConfig", "currentUser", "currentUserProfile"]),
    config() {
      return this.layoutConfig();
    },
    currentPage() {
      return this.search.currentPage;
    },
    globalTaxtType() {
      return (this.currentUserProfile && this.currentUserProfile.TaxType == "VAT")? "Vatable" : "";
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.setBreadcrumbs("Products");
      this.getData();
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Easy Receipt",
          route: "/easyreceipt"
        }
      ];
      payload.push({ title: value });
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    validateState(name, container) {
      if (container) {
        const { $dirty, $error } = container[name];
        return $dirty ? !$error : null;
      } else {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
      }
    },
    showProductPanel(show) {
      if(show) {
        this.openProductPanel = true;
        this.resetForm();
      } else {
        this.openProductPanel = false;
      }
    },
    resetForm(){
      this.form = {
        id : "",
        name : "",
        unit : "",
        price : "",
        taxtype : this.globalTaxtType
      }
      this.$nextTick(() => {
        this.$v.$reset();
        this.$v.form.$touch();
      });
    },
    setPageSize(value) {
      this.search.rowsPerPage = value;
      this.submitsearch();
    },
    async getData(){
      try {
        this.isBusy = true;
        const response = await ApiService.get("businessitems/me", {});
        this.items.data = response.data;
        this.isBusy = false;
        window.scrollTo(0, 0);
      } catch(er) {
        this.items.data = [];
        this.isBusy = false;
        window.scrollTo(0, 0);
      }
    },
    async save(addAnother) {
      try {
        this.isBusy = true;
        let response = null;
        if(this.form.id == "") {
          response = await ApiService.put("businessitems/add", {
            Description : this.form.name,
            Unit : this.form.unit,
            Price : this.form.price,
            TaxType : this.form.taxtype
          });
        } else {
          response = await ApiService.post("businessitems/edit", {
            BusinessItemId : this.form.id,
            Description : this.form.name,
            Unit : this.form.unit,
            Price : parseFloat(this.form.price),
            TaxType : this.form.taxtype
          });
        }

        if(response.data) {
          this.resetForm();
          if(!addAnother) {
            this.openProductPanel = false;
          }
        }
        this.getData();
        this.isBusy = false;
      } catch(er) {
        this.isBusy = false;
      }
    },
    confirmDeleteItem(item) {
      let self = this;
      Swal.fire({
        //title: 'Are you sure?',
        html: "Are you sure you want to delete this item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.isConfirmed) {
          self.delete(item.BusinessItemId)
        }
      });
    },
    async delete(BusinessItemId) {
      this.isBusy = true;
      try {
        const response = await ApiService.post("businessitems/delete", {
          BusinessItemId
        });
        if(response) {
          this.getData();
        }
        this.isBusy = false;
      } catch(er) {
        this.isBusy = false;
      }
    },
    edit(item) {
      this.showProductPanel(true);
      this.form = {
        id : item.BusinessItemId,
        name : item.MetadataObject.Description,
        unit : item.MetadataObject.Unit,
        price : item.MetadataObject.Price,
        taxtype : item.MetadataObject.TaxType ? item.MetadataObject.TaxType : "Vatable"
      }
    }
  },
  watch: {
    currentPage(newValue, oldValue) {
      if (newValue != oldValue) {
        this.submitsearch();
      }
    }
  }
};
</script>
